import { render, staticRenderFns } from "./addParcelInfo.vue?vue&type=template&id=2b364774"
import script from "./addParcelInfo.vue?vue&type=script&lang=js"
export * from "./addParcelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports